import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../../api";
import { logout } from "../../auth";
import { useUser } from '../../context/UserContext';
import ProfileSelectionUI from "../components/ProfileSelectionUI";

export default function ProfileSelection() {
  const { selectProfile, empresa, logoutTotal } = useUser();
  const navigate = useNavigate();

  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);

  // Estado para PIN (Inline)
  const [pin, setPin] = useState("");
  const [pinError, setPinError] = useState(false);
  const [validating, setValidating] = useState(false); // Estado para evitar doble envío


  // 1. Cargar Vendedores (solo activos)
  useEffect(() => {
    let mounted = true;
    apiFetch("/api/vendedores/listado?ocultar_inactivos=true&limit=1000")
      .then((res) => {
        if (res.ok) return res.json();
        throw new Error("Error fetching vendedores");
      })
      .then((data) => {
        if (mounted) {
          const vendedores = Array.isArray(data) ? data : data.items || [];
          const activos = vendedores.filter(v => v.activo !== false);
          setTeam(activos);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error(err);
        if (mounted) setLoading(false);
      });

    return () => { mounted = false; };
  }, []);

  const handleBack = () => navigate("/inicio");

  const handleLogout = () => {
    logout(() => {
      logoutTotal();
    });
  };

  const handleProfileSelect = (vendedor) => {
    // ✅ ACTUALIZAR CONTEXTO
    selectProfile({
      id: vendedor.id,
      vendedor_id: vendedor.id,
      nombre: vendedor.nombre,
      rol: "Vendedor",
      empresa_id: empresa.id,
    });
    navigate("/ventas/tablero");
  };

  // --- LÓGICA DE PIN INLINE ---

  const handlePinChange = (val) => {
    if (validating) return; // Bloquear input mientras valida

    // Si hay error previo, limpiar al escribir
    if (pinError) {
      setPinError(false);
      setPin(val.slice(-1));
      return;
    }

    const newPin = val.replace(/[^0-9]/g, "").slice(0, 4);
    setPin(newPin);

    // Al llegar a 4 dígitos, validar contra backend
    if (newPin.length === 4) {
      validatePin(newPin);
    }
  };

  const validatePin = async (inputPin) => {
    setValidating(true);
    try {
      const response = await apiFetch("/api/administradores/validate-pin", {
        method: "POST",
        body: JSON.stringify({ pin: inputPin }),
      });

      if (!response.ok) throw new Error("Error en validación");

      const data = await response.json();

      if (data.valid) {
        // ✅ ACTUALIZAR CONTEXTO ADMIN
        selectProfile({
          id: data.administrador.id,
          administrador_id: data.administrador.id,
          nombre: data.administrador.nombre,
          rol: "Admin",
          empresa_id: empresa.id,
        });
        navigate("/ventas/tablero");
      } else {
        // ❌ PIN INCORRECTO
        throw new Error("PIN inválido");
      }

    } catch (error) {
      console.error("Error validando PIN:", error);
      setPinError(true);

      // Limpiar después de la animación de error (1.3s)
      setTimeout(() => {
        setPin("");
        setPinError(false);
        setValidating(false); // Habilitar input nuevamente
      }, 1300);
    }
  };

  return (
    <ProfileSelectionUI
      empresaNombre={empresa?.nombre || "Empresa"}
      team={team}
      loading={loading}
      onBack={handleBack}
      onProfileSelect={handleProfileSelect}
      onLogout={handleLogout}

      // Props para PIN Inline
      pin={pin}
      pinError={pinError}
      onPinChange={handlePinChange}
    />
  );
}
